import API from '@/lib/API.js'
import comun from './comun.js'
const tipoafiliacion = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, valor) {
            state.Lista = valor;
        },
        select(state, valor) {
            state.Seleccionado = valor;
        },
    },
    actions: {
        async set({
            commit,
            state
        }) {
            if (state.Lista.length === 0) {
                commit("comun/cargando")
                let data = await API.Tipo_Afiliacion.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, valor) {
            commit("select", valor)
        },
        selectPorId({
            commit,
            state
        }, valor) {
            commit("comun/cargando")
            let sec = state.Lista.find((x) => x.id_tipo_afiliacion == valor)
            commit("select", sec)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let entidad = {
                id_tipo_afiliacion: 0,
                descripcion_afiliacion: ""
            }
            commit("select", entidad)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_tipo_afiliacion != 0) {
                data = await API.Tipo_Afiliacion.modificar(state.Seleccionado);
                str += "Tipo de afiliacion modificada"
            } else {
                data = await API.Tipo_Afiliacion.alta(state.Seleccionado);
                str += `Nueva Tipo de afiliacion de alta'${data.descripcion_afiliacion}'`
            }
            let entidades = await API.Tipo_Afiliacion.traerTodos();
            commit("set", entidades)
            dispatch("selectPorId", data.id_tipo_afiliacion)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_tipo_afiliacion != 0) {
                data = await API.Tipo_Afiliacion.modificar(entidad);
                str += "Tipo de afiliacion modificada"
            } else {
                data = await API.Tipo_Afiliacion.alta(entidad);
                str += `Nueva Tipo de afiliacion de alta'${data.descripcion_afiliacion}'`
            }
            let entidades = await API.Tipo_Afiliacion.traerTodos();
            commit("set", entidades)
            dispatch("selectPorId", data.id_tipo_afiliacion)
            commit("comun/mostrar", str)
        },
        async AgregarTipoDocumentacion({
            commit,
            state,
            rootState
        }, valor) {
            let p = await API.Tipo_documentaciones_tipo_afiliacion.Agregar(state.Seleccionado.id_tipo_afiliacion, valor.id_tipo_documentaciones, valor.Obligatorio);
            rootState.tipodocumentacionestipoafiliacion.Lista.push(p)
            commit("comun/mostrar", "Documentacion guardada")
        },
        async QuitarTipoDocumentacion({
            commit,
            state,
            rootState
        }, id_tipo_documentaciones) {
            let p = await API.Tipo_documentaciones_tipo_afiliacion.Quitar(id_tipo_documentaciones, state.Seleccionado.id_tipo_afiliacion);
            rootState.tipodocumentacionestipoafiliacion.Lista =
                rootState.tipodocumentacionestipoafiliacion.Lista.filter((x) => x.id_tipo_documentaciones !== id_tipo_documentaciones)
            commit("comun/mostrar", "Documentacion guardada")
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Tipo_Afiliacion.eliminar(id);
                str += "Tipo de afiliacion eliminada"
            }
            let ents = await API.Tipo_Afiliacion.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    modules: {
        comun,
    }
}
export default tipoafiliacion;